import React from 'react';
import {
  Button,
  Checkbox,
  Row,
  Modal,
  ModalProps,
  Space,
} from 'antd';
import { SmartFormLabel, SmartScannerInput, SmartSpace } from '../SmartComponent';

type Props = ModalProps & {
  codeLabel?: string;
  onSave: Function;
  options?: StringKAnyVPair[];
};

const CodeInputDialog = (props: Props) => {
  const { useState } = React;
  const [currentItemCode, setCurrentItemCode] = useState('');
  const [currentSubmitVersion, setCurrentSubmitVersion] = useState(0);
  const [inited, setInited] = useState(false);
  const [isItemChanged, setIsItemChanged] = useState(false);
  const [itemScannerCode, setItemScannerCode] = useState('');
  const [itemScannerVersion, setItemScannerVersion] = useState(0);
  const [lastSubmitVersion, setLastSubmitVersion] = useState(0);
  const [options, setOptions] = useState<StringKAnyVPair[]>([]);

  const dialogFooter = () => {
    return (
      <Row justify="end">
        <Space>
          <Button
            onClick={onCancel}
            size="large"
          >
            Cancel
          </Button>
          <Button
            disabled={!isItemChanged}
            onClick={onSave}
            size="large"
            style={{ minWidth: 82 }}
            type="primary"
          >
            Save
          </Button>
        </Space>
      </Row>
    );
  };

  const onCancel = (evt: any) => {
    if (props.onCancel) props.onCancel(evt);
  };

  const onChangeOption = (evt: any, idx: number) => {
    const checked = evt.target.checked;
    //console.log('c', options, idx);
    options[idx] && (options[idx].checked = checked);
    setOptions([...options]);
  };

  const onClearScannedItem = () => {
    setIsItemChanged(currentItemCode !== '');
    setCurrentItemCode('');
    setItemScannerCode('');
    setItemScannerVersion(itemScannerVersion + 1);
  };

  const onItemCodeChange = (evt: any) => {
    onScanItem(evt.target.value, false);
  };

  // eslint-disable-next-line
  const onSave = () => {
    props.onSave(currentItemCode, options);
    onCancel(undefined);
  };

  const onScanItem = (itemCode: string, isScan = true) => {
    const code = itemCode.trim();

    //console.log('->', currentItemCode, code);
    setCurrentItemCode(code);
    //setIsItemChanged(currentItemCode !== code);
    setIsItemChanged(true);
    isScan && setCurrentSubmitVersion(currentSubmitVersion + 1);
  };

  const renderOptions = (opts: StringKAnyVPair[]) => {
    return (
      <div className="mt-20">
        {opts.map((opt, i) => (
          <Checkbox
            defaultChecked={opt.defaultChecked}
            key={`opt${i}_${opt.value}`}
            onChange={(evt) => onChangeOption(evt, i)}
          >
            {opt.label}
          </Checkbox>
        ))}
      </div>
    );
  };

  React.useEffect(() => {
    if (!inited) {
      props.options && setOptions(props.options.map(opt => ({
        checked: opt.defaultChecked || false,
        value: opt.value,
      })));
      setTimeout(() => setItemScannerVersion(itemScannerVersion + 1), 500);
      setInited(true);
    }

    if (currentSubmitVersion !== lastSubmitVersion) {
      onSave();
      setLastSubmitVersion(currentSubmitVersion);
    }
  }, [
    currentSubmitVersion,
    inited,
    itemScannerVersion,
    lastSubmitVersion,
    onSave,
    props,
  ]);

  return (
    <Modal
      { ...props }
      footer={dialogFooter()}
    >
      <SmartSpace style={{ height: 'auto' }}>
        <SmartFormLabel className="fs-18 text-green-label">
          {props.codeLabel || 'Default Location'}
        </SmartFormLabel>
        <SmartScannerInput
          allowClear
          autoFocus
          className="fs-24 mt-2 mb-5 h-50"
          placeholder="Input location here"
          onClear={onClearScannedItem}
          onChange={onItemCodeChange}
          onScan={onScanItem}
          updateValue={itemScannerCode}
          version={itemScannerVersion}
        />
        {props.options && renderOptions(props.options)}
      </SmartSpace>
    </Modal>
  );
};

export default CodeInputDialog;
